import { type PermissionCheckMatch, type PermissionType, type EntityId, type PermissionEntityId } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { permissionCheckKey, permissionsKey } from '../keys'

export function usePermissionCache(): {
  clearEntityPermission: (entityId: PermissionEntityId) => void
  invalidatePermissionCheck: (permissionType: PermissionType, targetId: EntityId, match?: PermissionCheckMatch) => void
} {
  const queryClient = useQueryClient()

  const clearEntityPermission = (entityId: PermissionEntityId): void => {
    queryClient.invalidateQueries({ queryKey: permissionsKey(entityId) })
  }

  const invalidatePermissionCheck = (
    permissionType: PermissionType,
    targetId: EntityId,
    match?: PermissionCheckMatch
  ): void => {
    const queryKey = permissionCheckKey({ permissionType, targetId, match })
    queryClient.invalidateQueries({ queryKey: match ? queryKey : queryKey.slice(0, -1) })
  }

  return {
    clearEntityPermission,
    invalidatePermissionCheck,
  }
}
